import { useContext, useMemo } from "react";
import { ViewModeContext } from './ViewModeProvider'

export function useViewModeReadOnly() {
    const context = useContext(ViewModeContext)

    if (context === null) {
        throw 'Make sure this component has a ViewModeProvider'
    }

    return useMemo(() => context.readOnly, [context.readOnly])
}